import React from 'react';

import GlobalStyles from './styles/GlobalStyled';
import Layout from './components/Layout';

function App() {
  return (
    <>
        <Layout />
        
        <GlobalStyles/>
    </>
  );
}

export default App;
